// v1.28.15 — Prefix every downloadable report/ledger/statement filename
// with today's date in DD-MM-YYYY so a user's Downloads folder sorts
// chronologically. Applied at every `a.download = ...` site.
export const todayDDMMYYYY = () => {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
};

// Idempotent — if a filename already carries a DD-MM-YYYY_ prefix (or -)
// we return it untouched so we never end up with double prefixes.
export const withDatePrefix = (filename) => {
    if (!filename) return filename;
    if (/^\d{2}-\d{2}-\d{4}[_-]/.test(filename)) return filename;
    return `${todayDDMMYYYY()}_${filename}`;
};
